/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haiku Syllable Counter — 5-7-5 Checker | Toolverse`)
};

const es_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de sílabas para haiku — Verificador 5-7-5 | Toolverse`)
};

const de_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haiku-Silbenzähler — 5-7-5-Prüfer | Toolverse`)
};

const nl_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haiku Lettergreepteller — 5-7-5 Controle | Toolverse`)
};

const fr_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de syllabes pour haïku — Vérificateur 5-7-5 | Toolverse`)
};

const it_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di Sillabe per Haiku — Verifica 5-7-5 | Toolverse`)
};

const pt_br2_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Sílabas para Haiku — Verificador 5-7-5 | Toolverse`)
};

const pt_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Sílabas para Haiku — Verificador 5-7-5 | Toolverse`)
};

const ja_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俳句音節カウンター — 5-7-5チェッカー | Toolverse`)
};

const zh_syl_haiku_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俳句音节计数器 — 5-7-5检测器 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_meta_title", locale)
	if (locale === "en") return en_syl_haiku_meta_title(inputs)
	if (locale === "es") return es_syl_haiku_meta_title(inputs)
	if (locale === "de") return de_syl_haiku_meta_title(inputs)
	if (locale === "nl") return nl_syl_haiku_meta_title(inputs)
	if (locale === "fr") return fr_syl_haiku_meta_title(inputs)
	if (locale === "it") return it_syl_haiku_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_meta_title(inputs)
	if (locale === "pt") return pt_syl_haiku_meta_title(inputs)
	if (locale === "ja") return ja_syl_haiku_meta_title(inputs)
	return zh_syl_haiku_meta_title(inputs)
};